import React, {useEffect} from "react";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {Paper, TableContainer} from "@mui/material";
import ButtonComponent from "../common/buttons/ButtonComponent";
import "./ScheduleTable.sass"
import {ADDRESS} from "../../_api/client";
import {StyledTableCell, StyledTableRow} from "../TableComponents";
import {useDispatch} from "react-redux";
import {useLocation, useNavigate} from "react-router";
import {setEmpty} from "../../_actions/group/groupReducer";
import AddIcon from '@mui/icons-material/Add';
import moment from "moment";
import {colors} from "../../common/colors";

export default function ScheduleTable(props) {

    const {data} = props;
    const navigate = useNavigate()

    const style = {
        textAlign: 'center',
        fontSize: 'inherit'
    }

    const dispatch = useDispatch();
    const location = useLocation()

    useEffect(() => {
        return function test() {
            dispatch(setEmpty())
        }
    }, [location, dispatch]);

    const renderCourse = (course) => {
        if (!course) {
            return (
                <div>N/A</div>
            )
        }

        const courseStyle = {
            backgroundColor: course.color
        }

        return (
            <div style={courseStyle} className="course-item">
                {course.shortName}
            </div>
        )
    }

    const renderStudent = (students) => {
        const result = students.slice(0, 4).map((student, i) => {
            const title = `${student.firstName} ${student.lastName}`
            return (
                <div className="student-avatar-wrapper" key={`student-${student.id}`}>
                    <div style={{backgroundColor: colors[i % colors.length]}} className="student-avatar" title={title}>
                        {
                            student.img
                                ? <img src={`${ADDRESS}/avatar/${student.img}`} alt={title}/>
                                : <div style={{color: "white"}} className="student-count-else-text">
                                    {student.lastName[0].toUpperCase()}
                                    {student.firstName[0].toUpperCase()}
                            </div>
                        }
                    </div>
                </div>
            )
        })

        if (students.length > 4) {
            result[4] = <div key={`student-count-else}`} className="student-avatar-wrapper">
                <div className="student-count-else">
                    <div className="student-count-else-text">
                        +{students.length - 4}
                    </div>
                </div>
            </div>
        }

        return result;
    }

    return (
        <div>
            <TableContainer component={Paper}>
                <Table>
                    <caption style={style}>
                        {
                            data
                                ? <ButtonComponent onClick={() => navigate("/home/group/null")}>
                                    <AddIcon style={{fontSize: 'inherit', width: '1.7em', height: '1.7em'}}/>&nbsp;Добавить
                                    группу
                                </ButtonComponent>
                                : "Загрузка..."
                        }
                    </caption>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>Группа</StyledTableCell>
                            <StyledTableCell>Курс</StyledTableCell>
                            <StyledTableCell>Время</StyledTableCell>
                            <StyledTableCell>Ученики</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    {data &&
                        <TableBody>
                            {data.map((group) => (
                                <StyledTableRow key={"group-" + group.id}
                                                onClick={() => navigate(`/home/group/${group.id}`)}>
                                    <StyledTableCell component="th" scope="row">
                                        {group.name}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {group.course && renderCourse(group.course)}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {
                                            group.lesson
                                            && moment(`${group.lesson.date} ${group.lesson.time}`, "YYYY-MM-DD HH:mm:ss")
                                                .format('DD.MM ddd HH:mm')
                                        }
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <div className="student-avatars">
                                            {group.students && renderStudent(group.students)}
                                        </div>
                                    </StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    }
                </Table>
            </TableContainer>
        </div>
    )
}
